import { useState, useRef } from "react";
import { AppType, ChatModel, ChatSessionMode } from "../../../api/models";
import { QuestionDetails, Histories } from "../../../api";

/**
 * Custom hook for managing chat-related state
 */
export const useChatState = (initialAppType: AppType, defaultChatModel: ChatModel) => {
    const [answers, setAnswers] = useState<[user: QuestionDetails, response: any][]>([]);
    const [histories, setHistories] = useState<Histories>({});
    const [versionIndexMap, setVersionIndexMap] = useState<Record<string, number>>({});
    const [allAnswersTree, setAllAnswersTree] = useState<any[]>([]);
    const [conversationDetails, setConversationDetails] = useState<any[]>([]);

    const [selectedAppType, setSelectedAppType] = useState<AppType>(initialAppType);
    const [chatModel, setChatModel] = useState<ChatModel>(defaultChatModel);
    const [currentView, setCurrentView] = useState<ChatSessionMode>("chat");
    const [currentIndex, setCurrentIndex] = useState<string>("");
    const [selectedSessionId, setSelectedSessionId] = useState("");
    const [newChatQuestion, setnewChatQuestion] = useState<string>("");

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isAnswerLoading, setIsAnswerLoading] = useState<boolean>(false);
    const [isStreaming, setIsStreaming] = useState<boolean>(false);
    const [isSessionLoading, setIsSessionLoading] = useState<boolean>(false);
    const [isHistoryPageInitialLoading, setIsHistoryPageInitialLoading] = useState<boolean>(false);
    const [isNewChatThreadInitialLoading, setIsNewChatThreadInitialLoading] = useState<boolean>(false);
    const [error, setError] = useState<unknown>();

    const [selectedAnswer, setSelectedAnswer] = useState<number>(0);
    const [selectedQuestion, setSelectedQuestion] = useState<number>(0);
    const [IsOnEdit, setIsOnEdit] = useState<boolean>(false);
    const [isOnSave, setIsOnSave] = useState<boolean>(false);
    const [isEdited, setIsEdited] = useState<boolean>(false);
    const [isChatShared, setIsChatShared] = useState<boolean>(false);
    const [sessionId, setSessionId] = useState<string>("");

    const [clearChatTriggered, setClearChatTriggered] = useState<boolean>(false);
    const [chatContentCleared, setChatContentCleared] = useState<boolean>(false);
    const [scrollToAnswer, setScrollToAnswer] = useState<boolean>(false);
    const [isSessionNotFound, setIsSessionNotFound] = useState<boolean>(false);

    // Refs
    const lastQuestionRef = useRef<QuestionDetails>({
        question: "",
        templateId: "None",
        extractedQuestion: "",
        combinedAppTypeResponse: false,
        isFilesAttached: false,
        filesAttached: []
    });

    const currentQuestionInfo = useRef<any>(null);
    const lastAnswerRef = useRef<any>("");
    const lastDataPointsRef = useRef<any[]>([]);
    const lastThoughtsRef = useRef<string | null>("");
    const lastFollowUpRef = useRef<string[] | null>([]);
    const lastKeyWordRef = useRef<string | null>("");
    const lastAnswerIndexRef = useRef<number>(-1);
    const currentTargetQuestionId = useRef(-1);
    const lastQuestionIndexValue = useRef(0);
    const conversationId = useRef<string>("");
    const isTabClick = useRef<string>("false");

    return {
        // State
        answers,
        setAnswers,
        histories,
        setHistories,
        versionIndexMap,
        setVersionIndexMap,
        allAnswersTree,
        setAllAnswersTree,
        conversationDetails,
        setConversationDetails,
        selectedAppType,
        setSelectedAppType,
        chatModel,
        setChatModel,
        currentView,
        setCurrentView,
        currentIndex,
        setCurrentIndex,
        selectedSessionId,
        setSelectedSessionId,
        newChatQuestion,
        setnewChatQuestion,
        isLoading,
        setIsLoading,
        isAnswerLoading,
        setIsAnswerLoading,
        isStreaming,
        setIsStreaming,
        isSessionLoading,
        setIsSessionLoading,
        isHistoryPageInitialLoading,
        setIsHistoryPageInitialLoading,
        isNewChatThreadInitialLoading,
        setIsNewChatThreadInitialLoading,
        error,
        setError,
        selectedAnswer,
        setSelectedAnswer,
        selectedQuestion,
        setSelectedQuestion,
        IsOnEdit,
        setIsOnEdit,
        isOnSave,
        setIsOnSave,
        isEdited,
        setIsEdited,
        isChatShared,
        setIsChatShared,
        sessionId,
        setSessionId,
        clearChatTriggered,
        setClearChatTriggered,
        chatContentCleared,
        setChatContentCleared,
        scrollToAnswer,
        setScrollToAnswer,
        isSessionNotFound,
        setIsSessionNotFound,
        // Refs
        currentQuestionInfo,
        lastQuestionRef,
        lastAnswerRef,
        lastDataPointsRef,
        lastThoughtsRef,
        lastFollowUpRef,
        lastKeyWordRef,
        lastAnswerIndexRef,
        currentTargetQuestionId,
        lastQuestionIndexValue,
        conversationId,
        isTabClick
    };
};
